class TemplateSearchSuggestions {
  static MAX_SUGGESTIONS = 5;

  static init() {
    this.container = document.querySelector('.template-search__suggestions');
    this.list = document.querySelector('[data-template-search-suggestions]');
    this.abortController = null;
  }

  static renderFromMarkup(markup) {
    if (!this.list) return;

    const doc = new DOMParser().parseFromString(`<div>${markup}</div>`, 'text/html');
    const links = doc.querySelectorAll('#predictive-search-results-queries-list a.predictive-search__item');

    this.list.innerHTML = '';

    if (links.length === 0) {
      this.setVisible(false);
      return;
    }

    Array.from(links)
      .slice(0, this.MAX_SUGGESTIONS)
      .forEach((link) => {
        const item = link.cloneNode(true);
        item.setAttribute('tabindex', '-1');
        this.list.appendChild(item);
      });

    this.setVisible(true);
  }

  static clear() {
    if (!this.list) return;
    this.list.innerHTML = '';
    this.setVisible(false);
  }

  static setVisible(visible) {
    if (this.container) {
      this.container.classList.toggle('hidden', !visible);
    }
  }

  static fetch(searchTerm) {
    if (!this.list || !searchTerm.length || !window.routes?.predictive_search_url) {
      this.clear();
      return;
    }

    this.abortController?.abort();
    this.abortController = new AbortController();

    fetch(
      `${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search`,
      { signal: this.abortController.signal }
    )
      .then((response) => {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then((text) => {
        const section = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search');

        if (section) {
          this.renderFromMarkup(section.innerHTML);
        } else {
          this.clear();
        }
      })
      .catch((error) => {
        if (error?.name === 'AbortError') return;
        this.clear();
      });
  }
}

class MainSearch extends SearchForm {
  constructor() {
    super();
    this.allSearchInputs = document.querySelectorAll('input[type="search"]');
    TemplateSearchSuggestions.init();
    this.setupEventListeners();

    const initialTerm = this.input?.value?.trim();
    if (initialTerm) {
      TemplateSearchSuggestions.fetch(initialTerm);
    }
  }

  setupEventListeners() {
    let allSearchForms = [];
    this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));
    this.input.addEventListener('focus', this.onInputFocus.bind(this));
    if (allSearchForms.length < 2) return;
    allSearchForms.forEach((form) => form.addEventListener('reset', this.onFormReset.bind(this)));
    this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInput.bind(this)));
  }

  onChange() {
    super.onChange();
    if (!this.closest('predictive-search')) {
      const term = this.input?.value?.trim() || '';
      if (term) {
        TemplateSearchSuggestions.fetch(term);
      } else {
        TemplateSearchSuggestions.clear();
      }
    }
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync('', this.input);
      TemplateSearchSuggestions.clear();
    }
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
  }

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen) {
      this.scrollIntoView({ behavior: 'smooth' });
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) {
        input.value = value;
      }
    });
  }
}

customElements.define('main-search', MainSearch);
window.TemplateSearchSuggestions = TemplateSearchSuggestions;
